export default "__VITE_ASSET___7HVbmLe__"